import { render, staticRenderFns } from "./room-label-list.vue?vue&type=template&id=19ec4e59"
import script from "./room-label-list.vue?vue&type=script&lang=ts"
export * from "./room-label-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports